import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatStepperModule } from '@angular/material/stepper';
import { MatNativeDateModule } from '@angular/material/core';

import { MessageDialogComponent } from './message-dialog/message-dialog.component';
import { SizeFormatPipe } from '../helper/size-format.pipe';
import { SpinnerModule } from './spinner/spinner.module';
import { StatusCssClassPipe } from '../helper/status-css-class.pipe';
import { VolumeFormatPipe } from '../helper/volume-format.pipe';
import { StatusFormatPipe } from '../helper/status-format.pipe';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AttributeViewerModule } from './attribute-viewer/attribute-viewer.module';
import { QuantitySelectorModule } from './select/quantity-selector/quantity-selector.module';
import { AddressSelectorComponent } from './select/address-selector/address-selector.component';
import { PackageDataComponent } from './input/package-data/package-data.component';
import { UserSelectComponent } from './select/user-select/user-select.component';
import { HealthAnalysisStepPipe } from './pipe/pipe/step-format.pipe';
import { CapitalizePipe } from './pipe/pipe/capitalize.pipe';
import { SkeletonLoaderModule } from './skeleton-loader/skeleton-loader.module';
import { SelectorModule } from './select/selector/selector.module';
import { DeliveryServiceCodeComponent } from './input/delivery-service-code/delivery-service-code.component';
import { InlineMessageComponent } from './inline-message/inline-message.component';
import { ColorPickerModule } from './color-picker/color-picker.module';
import { PartnerSelectComponent } from './select/partner-select/partner-select.component';
import { PartnerArrayInputComponent } from './input/partner-array-input/partner-array-input.component';
import { ImageInputModule } from './input/image-input/image-input.module';
import { PrescriberArrayInputComponent } from './input/prescriber-array-input/prescriber-array-input.component';

@NgModule({
    declarations: [
        MessageDialogComponent,
        SizeFormatPipe,
        VolumeFormatPipe,
        StatusCssClassPipe,
        StatusFormatPipe,
        AddressSelectorComponent,
        UserSelectComponent,
        PackageDataComponent,
        DeliveryServiceCodeComponent,
        InlineMessageComponent,
        HealthAnalysisStepPipe,
        CapitalizePipe,
        PartnerSelectComponent,
        PartnerArrayInputComponent,
        PrescriberArrayInputComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatTooltipModule,
        MatMenuModule,
        SpinnerModule,
        ReactiveFormsModule,
        MatTableModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatTabsModule,
        MatStepperModule,
        NgxMaskPipe,
        NgxMaskDirective,
        AttributeViewerModule,
        QuantitySelectorModule,
        MatNativeDateModule,
        SkeletonLoaderModule,
        SelectorModule,
        ColorPickerModule,
        ImageInputModule,

    ], exports: [
        MatButtonModule,
        MatTooltipModule,
        MatMenuModule,
        SpinnerModule,
        MatStepperModule,
        ReactiveFormsModule,
        MessageDialogComponent,
        MatAutocompleteModule,
        MatTableModule,
        MatSelectModule,
        MatTabsModule,
        AddressSelectorComponent,
        PackageDataComponent,
        DeliveryServiceCodeComponent,
        VolumeFormatPipe,
        StatusCssClassPipe,
        StatusFormatPipe,
        SizeFormatPipe,
        NgxMaskPipe,
        NgxMaskDirective,
        AttributeViewerModule,
        QuantitySelectorModule,
        MatNativeDateModule,
        UserSelectComponent,
        HealthAnalysisStepPipe,
        InlineMessageComponent,
        CapitalizePipe,
        ColorPickerModule,
        ImageInputModule,
        PartnerSelectComponent,
        PartnerArrayInputComponent,
        PrescriberArrayInputComponent
    ],
    providers: [
        provideNgxMask()
    ]
})
export class SharedModule { }
